import { useGetEncountersQuery } from "src/api/services/encounterApi";
import MeetingCard from "../MeetingCard";
import RequestSyncVisit from "../RequestSyncVisit";

const MeetingSlot = () => {
  const { data = [], isSuccess } = useGetEncountersQuery({
    status: "requested",
  });

  if (data.length > 0 && isSuccess === true) {
    return data.map((encounter) => {
      return <MeetingCard meeting={encounter} key={encounter.room_url} />;
    });
  }

  if (isSuccess === true && data.length === 0) {
    return <RequestSyncVisit />;
  }

  return null;
};

export default MeetingSlot;
